import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip } from "antd";
import configure from "configure";
import moment from "moment";
import { getInitials } from "utils/common-helpers";
export const AdminTimerColumn = (onStop) => [
  {
    Header: () => <div className="text-center">User</div>,
    accessor: "user",
    Cell: ({ row }) => {
      const { avatar, alias_name } = row.original.user || {};

      return (
        <div
          className="d-flex align-items-center justify-content-center gap-1"
          style={{ whiteSpace: "nowrap" }}
        >
          <Tooltip color={"#752b97"} title={`${alias_name || "-"}`}>
            {avatar ? (
              <>
                {console.log("that")}
                <img
                  src={`${configure.imgUrl}${avatar}`}
                  alt="Profile"
                  className="rounded-circle"
                  width="24"
                  height="24"
                />
              </>
            ) : (
              <>
                {console.log("This")}
                <div className="defualt-img " title={alias_name}>
                  {getInitials(alias_name || "Z")}
                </div>
              </>
            )}
          </Tooltip>
        </div>
      );
    },
    style: { width: "80px", maxWidth: "80px" },
  },
  {
    Header: <div className="text-start">Project</div>,
    accessor: "project.project_name",
    id: "project_name",
    Cell: ({ row }) => {
      const { project_name } = row.original.project || {};
      return <span>{project_name}</span>;
    },
    style: { width: "250px", maxWidth: "250px" },
  },
  {
    Header: <div className="text-start">Task</div>,
    accessor: "task.task_title",
    id: "task_title",
    Cell: ({ row }) => {
      const { task_id, task_title } = row.original.task || {};
      return (
        <span>
          #{task_id} - {task_title}
        </span>
      );
    },
    style: { width: "250px", maxWidth: "250px" },
  },
  {
    Header: "Timer",
    accessor: "start_time",
    id: "start_time",
    Cell: ({ row }) => {
      const start_time = new Date(row.original.start_time);
      const type = row.original.type;
      const end = row.original.end_time
        ? new Date(row.original.end_time).toLocaleTimeString()
        : "--";
      const formattedTime =
        type === "code_review"
          ? new Date(start_time.getTime() + 5.5 * 60 * 60 * 1000)
              .toISOString()
              .replace("T", " ")
              .substring(0, 16)
          : start_time.toISOString().replace("T", " ").substring(0, 16);
      return (
        <div className="d-flex flex-column align-items-center">
          <span>{moment(formattedTime).format("DD-MM-YYYY HH:mm")}</span>
        </div>
      );
      // const { start_time: rawStartTime, end_time: rawEndTime, type } = row.original;
      // let startTime = moment(rawStartTime);
      // if (type === "code_review") {
      //   startTime = startTime.add(5.5, 'hours');
      // }
      // const formattedDateTime = startTime.format('DD-MM-YYYY hh:mm A');
      // const endTime = rawEndTime ? moment(rawEndTime).format('hh:mm A') : "--";
      // return (
      //   <div className="d-flex flex-column align-items-center">
      //     <span>{formattedDateTime}</span>
      //   </div>
      // );
    },
    style: { width: "110px", maxWidth: "110px" },
  },
  {
    Header: () => <div className="text-center">Action</div>,
    accessor: "action",
    id: "actionColumn",
    Cell: ({ row }) => {
      return (
        <div className="d-flex justify-content-center gap-1">
          <button
            className="btn btn-sm btn-outline-danger me-1"
            title="Start / Stop Timer"
            onClick={() => onStop(row.original)}
          >
            <i className="fa fa-stopwatch"></i>
          </button>
        </div>
      );
    },
    style: { width: "60px", maxWidth: "60px" },
  },
];
